import { render, staticRenderFns } from "./AdminPriceLimits.vue?vue&type=template&id=dda6070a"
import script from "./AdminPriceLimits.vue?vue&type=script&lang=js"
export * from "./AdminPriceLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dda6070a')) {
      api.createRecord('dda6070a', component.options)
    } else {
      api.reload('dda6070a', component.options)
    }
    module.hot.accept("./AdminPriceLimits.vue?vue&type=template&id=dda6070a", function () {
      api.rerender('dda6070a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminPriceLimits.vue"
export default component.exports